import Model from './Model'
import moment from "moment";

export default class ProgressReportOld extends Model {

    getFormAttributes() {
        const attributes = this.only([
            'comments', 'housekeeping', 'id', 'new_item_values', 'new_preliminary_values', 'quality_of_work', 'site_safety',
            'unfixed_materials_value', 'weather', 'work_as_spec', 'date'
        ])
        attributes.date = this.date.toISOString();
        return attributes
    }

    static parseAttributes(attributes = {}) {
        attributes = this.parseDropdownAttributes(attributes);
        return attributes
    }

    setAttributes(attributes) {
        super.setAttributes(attributes);
        let tokens = [
            attributes.formatted_date,
            attributes.created_by,
        ]
        let ds = moment(this.date);
        this.date = ds.toDate()
        this.tokens = tokens.join('|').toLowerCase();
    }
}

